var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2847_48871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C2.05502 7.80104 3.97811 6.89792 5.44359 5.44359C6.89792 3.97811 7.80104 2.05502 8 0C8.19896 2.05502 9.10208 3.97811 10.5564 5.44359C12.0219 6.89792 13.945 7.80104 16 8C13.9429 8.19125 12.0173 9.09553 10.5564 10.5564C9.09553 12.0173 8.19125 13.9429 8 16C7.80104 13.945 6.89792 12.0219 5.44359 10.5564C3.97811 9.10208 2.05502 8.19896 0 8Z",
    fill: "#86858B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2847_48871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/Magic.1bc9515d996e256f5b2321f549838192.svg";
export { ForwardRef as ReactComponent };